import { GET_LIST, GET_ONE } from 'react-admin';
import queryString from 'query-string';
import { cms1500JobsFields } from "./cms1500Jobs.model";
import { getApiUrlForResource } from '../services/apiUrlResolver';
import logger from '../utils/logger';
export const CMS1500_JOBS_RESOURCE_NAME = "cms1500-jobs";
export const POST_FORCE_RETRY = "POST_FORCE_RETRY";

// Helper function to get API URL at request time
const getApiUrl = () => {
  return getApiUrlForResource('cms1500Jobs'); // Use camelCase for flag mapping
};

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case GET_LIST:
            return composeGetCms1500JobsListRequest(requestParams);
        case GET_ONE:
            return { url: `${getApiUrl()}/${CMS1500_JOBS_RESOURCE_NAME}/${requestParams.id}` };
        case POST_FORCE_RETRY:
            const baseUrl = getApiUrl();
            const forceRetryUrl = `${baseUrl}/${CMS1500_JOBS_RESOURCE_NAME}/${requestParams.id}/force-retry`;
            logger.log(`[CMS-1500 Force Retry] Constructed URL: ${forceRetryUrl}`);
            logger.log(`[CMS-1500 Force Retry] Request params:`, requestParams);
            logger.log(`[CMS-1500 Force Retry] Request body:`, { 
                form_answer_group_id: requestParams.form_answer_group_id,
                force: true 
            });
            return {
                url: forceRetryUrl,
                options: {
                    method: 'POST',
                    body: JSON.stringify({ 
                        form_answer_group_id: requestParams.form_answer_group_id,
                        force: true 
                    })
                },
            };
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

const composeGetCms1500JobsListRequest = (requestParams) => {
    const { page, perPage } = requestParams.pagination;
    const { field, order } = requestParams.sort;
    let prepareFilters = () => {
        let requestFilters = requestParams.filter;
        if (requestFilters === undefined) {
            return {};
        }
        let createContainsFilter = (name, value) => ({ name, comparison: "contains", value });
        let createEqFilter = (name, value) => ({ name, comparison: "eq", value });
        let createDateBetweenFromFilter = (name, value) => ({ name, comparison: "betweenFrom", value });
        let createDateBetweenToFilter = (name, value) => ({ name, comparison: "betweenTo", value });

        let resultFilters = [];
        if (requestFilters.hasOwnProperty(cms1500JobsFields.id)) {
            resultFilters.push(createContainsFilter('id', requestFilters[cms1500JobsFields.id]));
        }
        if (requestFilters.hasOwnProperty(cms1500JobsFields.formAnswerGroupId)) {
            resultFilters.push(createContainsFilter('form_answer_group_id', requestFilters[cms1500JobsFields.formAnswerGroupId]));
        }
        if (requestFilters.hasOwnProperty(cms1500JobsFields.patientId)) {
            resultFilters.push(createContainsFilter('patient_id', requestFilters[cms1500JobsFields.patientId]));
        }
        if (requestFilters.hasOwnProperty(cms1500JobsFields.appointmentId)) {
            resultFilters.push(createContainsFilter('appointment_id', requestFilters[cms1500JobsFields.appointmentId]));
        }
        if (requestFilters.hasOwnProperty(cms1500JobsFields.healthieCms1500Id)) {
            resultFilters.push(createContainsFilter('healthie_cms1500_id', requestFilters[cms1500JobsFields.healthieCms1500Id]));
        }
        if (requestFilters.hasOwnProperty(cms1500JobsFields.status)) {
            resultFilters.push(createContainsFilter('status', requestFilters[cms1500JobsFields.status]));
        }
        if (requestFilters.hasOwnProperty('createdBetween')) {
            let between = requestFilters['createdBetween'];
            if (between.gte != null) {
                resultFilters.push(createDateBetweenFromFilter('createdAtFrom', between.gte));
            }
            if (between.lte != null) {
                resultFilters.push(createDateBetweenToFilter('createdAtTo', between.lte));
            }
        }
        return resultFilters;
    };

    const queryParams = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage]),
        filters: JSON.stringify(prepareFilters()),
        export: requestParams.export
    };

    return { url: `${getApiUrl()}/${CMS1500_JOBS_RESOURCE_NAME}?${queryString.stringify(queryParams)}` };
}

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    const { headers, json } = httpResponse;

    switch (requestType) {
        case GET_LIST:
            if (json['url'] != null) { // Large Export Hack -- a url is returned to a presigned s3 file for download, handled downstream.
              return { data: [{ id: 9999999, url: json['url']}], total: 9999999 }; // Have to use this format as part of the hack to slip through react-admin validation
            }
            return {
                data: json.map(x => x),
                total: parseInt(headers.get('content-range').split('/').pop()),
            };
        default:
            return { data: json };
    }
};

export default {
    resource: CMS1500_JOBS_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
};
